import Styles from './components.module.scss';
import { ComponentProps } from 'react';

type Props = ComponentProps<'form'> & {
	children: React.ReactNode;
};
export default function FiltrosContainer({ children, ...props }: Props) {
	return (
		<div className={`${Styles.filtros_container} tour-relatorio-3`}>
			<form {...props} className={Styles.filtros_list}>{children}</form>
		</div>
	);
}
